export const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";
// export const apiUrl = "http://localhost:5000";
export const opencageAPIkey = process.env.REACT_APP_OPENCAGE_API_KEY;
export const googleAPIkey = process.env.REACT_APP_GOOGLE_API;
export const cloudinaryUrl = process.env.REACT_APP_CLOUDINARY_URL;

export const cloud_name = process.env.REACT_APP_CLOUD_NAME;
export const upload_preset = process.env.REACT_APP_UPLOAD_PRESET;
export const DEFAULT_MESSAGE_TIMEOUT = 3000;
